import {
  navigationRoutes,
  navigationSteps
} from '../navigation/navigationHelpers';

const dataConfig = {
  auth: {
    state: 'auth',
    message: '',
    endpoint: navigationRoutes[navigationSteps.myPlan.MYPLAN].endpoints.validateAuth
  },
  context: {
    state: 'context',
    message: '',
    endpoint: navigationRoutes[navigationSteps.myPlan.MYPLAN].endpoints.getContext
  },
  customer: {
    state: 'customer',
    message: '',
    endpoint: navigationRoutes[navigationSteps.myPlan.MYPLAN].endpoints.loadCustomer
  },
  plan: {
    state: 'plan',
    message: '',
    endpoint: navigationRoutes[navigationSteps.myPlan.MYPLAN].endpoints.loadPlan
  },
  equipment: {
    state: 'equipment',
    message: '',
    endpoint: navigationRoutes[navigationSteps.myPlan.MYPLAN].endpoints.loadEquipment
  },
  offers: {
    state: 'offers',
    message: '',
    endpoint: navigationRoutes[navigationSteps.myPlan.OFFERS].endpoints.loadContent
  },
  checkEligibility: {
    state: 'alwaysCall',
    message: '',
    endpoint: navigationRoutes[navigationSteps.myPlan.ADDON_CHANNEL].endpoints.checkEligibility
  },
  addDefaultOffer: {
    state: 'addDefaultOffer',
    message: '',
    endpoint: navigationRoutes[navigationSteps.quickCheckout.CHECKOUT].endpoints.addDefaultOffer
  },
  productMapping: {
    state: 'productMapping',
    message: '',
    endpoint: navigationRoutes[navigationSteps.quickCheckout.CHECKOUT].endpoints.validateProductMapping
  },
  customerLobAndProduct: {
    state: 'customerLobAndProduct',
    message: '',
    endpoint: navigationRoutes[navigationSteps.quickCheckout.CHECKOUT].endpoints.validateCustomerLobAndProduct
  },
  productForQuickcheckout: {
    state: 'productForQuickcheckout',
    message: '',
    endpoint: navigationRoutes[navigationSteps.quickCheckout.CHECKOUT].endpoints.validateProductForQuickcheckout
  },
  configureProduct: {
    state: 'configureProduct',
    message: '',
    endpoint: navigationRoutes[navigationSteps.quickCheckout.CHECKOUT].endpoints.configureProductToCart
  },
  review: {
    state: 'review',
    message: '',
    endpoint: navigationRoutes[navigationSteps.quickCheckout.REVIEW].endpoints.reviewCart
  },
  reviewPlanCart: {
    state: 'review',
    message: '',
    endpoint: navigationRoutes[navigationSteps.myPlan.REVIEW].endpoints.reviewCart
  },
  submitOrder: {
    state: 'submitOrder',
    message: '',
    endpoint: navigationRoutes[navigationSteps.quickCheckout.REVIEW].endpoints.submitOrder
  },
  confirmation: {
    state: 'confirmation',
    message: '',
    endpoint: navigationRoutes[navigationSteps.quickCheckout.CONFIRMATION].endpoints.getConfirmation
  },
  myplanConfirmation: {
    state: 'myplanConfirmation',
    message: '',
    endpoint: navigationRoutes[navigationSteps.myPlan.CONFIRMATION].endpoints.getConfirmation
  },
  quickCheckoutAnalytics: {
    state: 'alwaysCall',
    message: '',
    endpoint: navigationRoutes[navigationSteps.quickCheckout.CHECKOUT].endpoints.analytics
  },
  moversInstall: {
    state: 'alwaysCall',
    message: '',
    endpoint: navigationRoutes[navigationSteps.movers.INSTALL].endpoints.loadInstall
  },
  moversReview: {
    state: 'alwaysCall',
    message: '',
    endpoint: navigationRoutes[navigationSteps.movers.REVIEW].endpoints.loadReview
  },
  moversConfirmation: {
    state: 'alwaysCall',
    message: '',
    endpoint: navigationRoutes[navigationSteps.movers.CONFIRMATION].endpoints.loadConfirmation
  },
  accountMultipleAddress: {
    state: 'accountMultipleAddress',
    message: '',
    endpoint: navigationRoutes[navigationSteps.account.MULTIPLE_ADDRESS].endpoints.getAddresses
  },
  omniPrerequisites: {
    state: 'omniPrerequisites',
    message: '',
    endpoint: navigationRoutes[navigationSteps.myPlan.OMNI_LANDING].endpoints.getPrerequisites
  }
};

export default dataConfig;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/dataProvider/dataConfig.js
 **/